import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectHouseFullAddress, selectHouseId } from 'shared/selectors/houseInfo';
import { selectUserEmail, selectIsAuthenticatedUser } from 'shared/selectors/user';
import { ISearchParams } from '../types';
import { selectJsonQuery } from 'shared/selectors/offers';

export const useSearchParams = (): ISearchParams => {
  const email = useSelector(selectUserEmail);
  const isAuthenticated = useSelector(selectIsAuthenticatedUser);
  const houseAddress = useSelector(selectHouseFullAddress);
  const houseId = useSelector(selectHouseId);
  const jsonQuery = useSelector(selectJsonQuery);

  return useMemo(
    () => ({
      email,
      isAuthenticated,
      title: houseAddress,
      jsonQuery,
      modalTitle: 'Добавить дом в избранное',
      submitButtonText: 'Добавить дом в избранное',
      analyticsParams: {
        pageType: 'CardHS',
        listingType: 'list',
        offerId: houseId,
        queryString: typeof window === 'undefined' ? /* istanbul ignore next */ '' : window.location.search.slice(1),
        isFromBanner: false,
      },
    }),
    [email, houseAddress, houseId, isAuthenticated, jsonQuery],
  );
};
